<script setup>
import RegistrationCard from "../../../views/login/registration/components/RegistrationCard.vue";
import RegistrationHero from "../../../views/login/registration/components/RegistrationHero.vue";
import AgencyRegistrationForm from "./AgencyRegistrationForm.vue";
import {onMounted} from "vue";
import {useStore} from "vuex";

const props = defineProps({
  preview: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "You’re 1 Min Away From Getting Started",
  },
  subtitle: {
    type: String,
    default: null,
  },
  logo: {
    type: String,
    default: null,
  },
  countries: {
    type: Object,
    required: true,
  },
  userCountry: {
    type: Object,
    required: true,
  },
  currency: {
    type: String,
    default: 'USD',
  },
  discountCode: {
    type: String,
    default: null,
  },
  supportRequired: {
    type: Boolean,
    default: false,
  },
  availableCurrencies: {
    type: Object,
    required: true,
  },
  availableBillingPeriods: {
    type: Object,
    required: true,
  },
  whitelabel: {
    type: Boolean,
    default: false,
  }
});

const store = useStore();

onMounted(() => {
  let {
    userCountry,
    currency,
    discountCode,
    supportRequired,
    countries,
    availableCurrencies,
    availableBillingPeriods,
    whitelabel
  } = props;

  if (userCountry.name) {
    store.dispatch('registration/setOperationCountry', {
      value: userCountry.name,
      countries: countries
    });
  }

  if (userCountry.code === 'GB') {
    currency = 'GBP';
  }

  // Ensure currency is valid, if not, fallback.
  if (!['GBP', 'USD', 'gbp', 'usd'].includes(currency)) {
    currency = 'USD';
  }

  // Ensure uppercase, for string comparisons in the back-end
  currency = currency.toUpperCase();

  if (availableCurrencies[currency] === false) {
    for (var currentCurrency in availableCurrencies) {
      if (availableCurrencies[currentCurrency] === true) {
        currency = currentCurrency;
      }
    }
  }

  let billingPeriod = 'MONTH';

  if (availableBillingPeriods[billingPeriod] === false) {
    for (var currentBillingPeriod in availableBillingPeriods) {
      if (availableBillingPeriods[currentBillingPeriod] === true) {
        billingPeriod = currentBillingPeriod;
      }
    }
  }

  store.dispatch('registration/setConfiguration',
      {
        userCountry,
        currency,
        billingPeriod,
        discountCode,
        supportRequired,
        whitelabel,
      });

  // If we don't have user country from ip address & the currency is set to DEFAULT USD
  // we should ignore the country that was set in session storage and default it also to 'USA'
  // This way we avoid the currency and country mismatch that can happen
  if (userCountry.name === null && currency === 'USD') {
    store.dispatch('registration/setOperationCountry', {
      value: 'United States',
      countries: countries
    })
  }

  const {title, subtitle, logo, preview} = props;
  store.dispatch('registration/setLayout', {
    title,
    subtitle,
    logo,
    preview,
  });
});
</script>

<template>
  <div class="container">
    <RegistrationHero
      :reseller="true"
      :logo="logo"
    >
      <RegistrationCard
        :reseller="true"
      >
        <AgencyRegistrationForm
          :preview="preview"
          :countries="countries"
          :whitelabel="whitelabel"
        />
      </RegistrationCard>
    </RegistrationHero>

    <div class="legal">
      <div class="legal-terms">
        <img
          src="/images/registration/stripe-cc-payments1.png"
          alt="Stripe Payments"
        >
        <span>All payments processed through <a
          href="https://stripe.com"
          target="_blank"
        >Stripe</a>.</span>
      </div>

      <div
        v-if="!preview"
        class="legal-terms"
      >
        We use industry standard encryption to protect your personal information,<br>
        <span>
          by signing up you agree to our
          <a
            href="https://hikeseo.co/terms-conditions/"
            target="_blank"
          >
            Terms &amp; Conditions
          </a>.
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.container {
  background-color: #fafafa;
  font-family: 'DM Sans', sans-serif !important;
  min-height: 100vh;
  height: 100%;

  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
}

.legal {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 1rem;
  height: 100%;
  color: #3E3E44;
  font-size: 11pt;
}

.legal-terms {
  text-align: center;
  display: inherit;
  flex-direction: column;
  align-items: center;
  color: #3E3E44;
  font-family: 'DM Sans', Arial, Helvetica, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
}

.legal-terms img {
  max-width: 10rem;
}

iframe {
  border: 0;
}
</style>
